import React, { useEffect } from 'react';
import { ChakraProvider, Center, VStack, Spinner, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from './redux/hooks';
import AppRoutes from './routes/AppRoutes';
import { theme } from './theme/aowTheme';
import './theme/app.css';
import 'leaflet/dist/leaflet.css';
import './setupAxios';
import './i18n';
import { bootstrapAuth } from './redux/reducers/AuthReducer';

export default function App() {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const { ready, isLoading } = useAppSelector(state => state.auth);

  // Bootstrap once
  useEffect(() => { dispatch(bootstrapAuth()); }, [dispatch]);

  if (!ready) {
    return (
      <ChakraProvider theme={theme}>
        <Center minH="100vh" bg="#22b8b4">
          <VStack spacing={3}>
            <Spinner size="lg" thickness="3px" speed="0.65s" />
            <Text fontSize="md" color="white" fontWeight="medium">
              {t('Loading')}
            </Text>
          </VStack>
        </Center>
      </ChakraProvider>
    );
  }

  return (
    <ChakraProvider theme={theme}>
      <AppRoutes />
    </ChakraProvider>
  );
}
